import React from 'react';
import { useParams } from 'react-router-dom';
import CoWorkingEventDetail from '../components/CoWorkingEventDetail';

const EventDetails: React.FC = () => {
    const { eventId } = useParams<{ eventId: string }>();

    if (!eventId) {
        return <div>Error: No event ID found in the URL.</div>;
    }

    return (
        <CoWorkingEventDetail params={{ eventId }} />
    );
};

export default EventDetails;
